import { SelectOption } from '../SelectOption/SelectOption';

interface NamedLocationCode {
    name: string;
    isoCode: string;
}

export const caseInsensitiveSort = (valueA: string, valueB: string): number => {
    if (!valueA) return 1;
    if (!valueB) return -1;

    return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
};

export const createLocationOptionsGetter = <T extends NamedLocationCode>(locationMap: Record<string, T>) => {
    const optionsCache: Partial<Record<'name' | 'isoCode', SelectOption[]>> = {};

    return (labelType: 'name' | 'isoCode' = 'name'): SelectOption[] => {
        if (!optionsCache[labelType]) {
            optionsCache[labelType] = Object.values(locationMap)
                .map(entry => ({
                    label: labelType === 'isoCode' ? entry.isoCode : entry.name,
                    value: entry.isoCode
                }))
                .sort((a, b) => caseInsensitiveSort(a.label, b.label));
        }

        return optionsCache[labelType] as SelectOption[];
    };
};
